import React, {Fragment} from 'react';
import Navbar from '../../components/Navbar'
import Hero3 from '../../components/hero3'
import Service2 from '../../components/Service2'
import AboutS3 from '../../components/AboutS3';
import Footer from '../../components/footer'
import Scrollbar from '../../components/scrollbar'
import Logo from '../../images/logo2.png'
import PartnerSection from '../../components/PartnerSection';
import ProjectSection2 from '../../components/ProjectSection2';
import CtaSection from '../../components/ctaSection';
//import vimg from '../../images/bird.png'
import vimg from '../../images/guy-mentor.jpg'
import CauseSection2 from '../../components/CauseSection2';
import Testimonial2 from '../../components/Testimonial2';
import TeamSection from '../../components/TeamSection'


const HomePage =() => {
    return(
        <Fragment>
            <Navbar Logo={Logo} hclass={'wpo-header-style-3'}/>
            <Hero3/>
            <AboutS3/>
            <Service2/>
            <CtaSection ctClass={'wpo-cta-area-s2'} vImg={vimg} cTitle={'Get Involved! Join us in driving change'}/>
            <CauseSection2 CmClass={'wpo-campaign-area-s2'}/>
            <TeamSection/>
            <PartnerSection/>
            <Scrollbar/>
            <Footer/>
        </Fragment>
    )
};
export default HomePage;